export default __webpack_public_path__ + "static/media/Img0006.e9ee370c.png";